import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9.914 12.965"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      transform: "rotate(90 61.174 -43.096)"
    }, [
      _createElementVNode("path", { d: "m112.395 10.201-1.37-.007a.58.58 0 0 1-.577-.583l.004-.87a.58.58 0 0 1 .583-.577l.79.004a.58.58 0 0 1 .577.583zM111.775 18.078l-.79-.004a.58.58 0 0 1-.577-.583l.004-.87a.58.58 0 0 1 .583-.577l1.37.007-.007 1.45a.58.58 0 0 1-.583.577zM115.287 12.113l1.37.007a.58.58 0 0 1 .577.583l-.004.88a.58.58 0 0 1-.583.577l-1.37-.007.01-2.03z" }),
      _createElementVNode("rect", {
        width: "6.31",
        height: "2.03",
        x: "104.27",
        y: "12.07",
        rx: ".48",
        ry: ".48",
        transform: "rotate(.29 108.7 13.555)"
      }),
      _createElementVNode("path", { d: "m115.285 12.121-2.32-.011a.58.58 0 0 1-.577-.583l.007-1.37 2.32.011a.58.58 0 0 1 .577.583zM114.685 16.068l-2.32-.011.007-1.37a.58.58 0 0 1 .583-.577l2.32.011-.007 1.37a.58.58 0 0 1-.583.577z" })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "down-arrow"}) } }